import * as React from 'react';

export const header = {
  heading: 'Manage Marketing Preferences  '
};
export const richText1 = {
  id: 'MarketingPreferences',
  html:
    '                <p>You can register or change your preferences to receive or not receive marketing \n'
    + '                 communications from us by clicking <a href="https://www.homedepot.com/c/Manage_Marketing_Preferences">\n'
    + '                 here</a>. Please allow sufficient time for your preferences to be processed. Even if you  \n'
    + '                 opt out of receiving marketing messages,we may still contact you for transactional purposes\n'
    + '                 like confirming or following up on an order or service request, responding to customer  \n'
    + '                 service inquiries, asking you to review a product or service you have ordered, or notifying\n'
    + '                 you of product recalls or rebates. And you may continue to see general audience marketing, \n'
    + '                 such as The Home Depot ads on other websites that are placed based on the content available \n'
    + '                 on the sites.  If you later opt back into getting marketing communications from us,\n'
    + '                 we will remove your information from our opt-out databases. </p> \n'
    + '                <p><br/></p>\n'
    + '               <p>Registered website users can update their information at the My Account section of our \n'
    + '                  website. If you are not a registered website user, refer to the Contact Us section \n'
    + '                  below for information about how you can contact us. </p> \n'
};
